import tw from 'twin.macro';
import styled from '@emotion/styled';

import { breakpoints } from '@/constants/breakpoints';

export const StyledColumn = styled.li`
  ${tw`flex flex-col gap-4 pb-4 lg:pb-0`}

  @media (max-width: ${breakpoints.DESKTOP - 1}px) {
    break-inside: avoid;
  }
`;
